import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from '../../../../actions/types';
import ArrowSlider from '../../../../components/ArrowSlider';
import HolderModal from '../../../../components/Modals/Holders Modal';
import OIMODAL from '../../../../components/Modals/OI Modal';
import OIWebTable from './OITable';
import OIStyle from '../../index.module.css';

const OIWebTableContainer = ({
  styles,
  tableRef,
  props,
  closeOIModal,
  lengthCheck,
  selectDate,
  makeModelRowData,
}) => {
  const state = useSelector((state) => state.OpenInterestState);
  const appReducer = useSelector((state) => state.appReducer);

  const dispatch = useDispatch();
  const setStateAction = (newState) =>
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    });
  return (
    <div
      ref={tableRef}
      style={{
        height: 'calc(100% - 150px)',
        width: '95%',
        margin: 'auto',
        overflowY: 'scroll',
      }}
    >
      <div style={styles.tablediv}>
        <div
          style={{
            position: 'sticky',
            zIndex: 4,
            left: '0px',
            display: 'table',
            height: '100%',
          }}
        >
          <div style={styles.currentPriceArrowsContainer}>
            <ArrowSlider
              height={0}
              arrowPos={0}
              yStartingPosition={state.arrowPosition}
              rowHeight={30}
              strikeArrow
              basicStrike
              isMobile={appReducer.isMobile}
              side={'left'}
            />
            <ArrowSlider
              height={0}
              arrowPos={0}
              yStartingPosition={state.arrowPosition}
              rowHeight={30}
              strikeArrow
              basicStrike
              isMobile={appReducer.isMobile}
              side={'right'}
            />
          </div>

          <Table stickyHeader className={OIStyle.OITableCustomization}>
            <TableHead>
              {props.OIStrikes.length > 0 && (
                <TableRow style={{ height: '31.5px' }}>
                  <TableCell style={styles.headercellst}>Strike</TableCell>
                </TableRow>
              )}
            </TableHead>
            <TableBody>
              {props.OIStrikes.map((row, rowindex) => (
                <TableRow key={rowindex} style={{ height: '30px' }}>
                  <TableCell style={styles.strikecell}>
                    {parseFloat(row).toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        <div className={OIStyle.OITableWrapper}>
          {state.isOIchecked ? (
            <OIMODAL
              accessLevel={props.accessLevel}
              showModal={state.isOIchecked}
              ticker={state.localTicker}
              expiration={state.expiration}
              modalRowData={state.modalRowData}
              closeOIModal={closeOIModal}
              selectedDate={state.selectedDate}
            />
          ) : (
            ''
          )}
          {state.holderModal && lengthCheck && (
            <HolderModal
              accessLevel={props.accessLevel}
              isMobile={appReducer.isMobile}
              holderList={appReducer.holderList}
              showModal={state.holderModal}
              setShowModal={() => setStateAction({ holderModal: false })}
              symbol={state.localTicker}
            />
          )}
          <OIWebTable
            styles={styles}
            selectDate={(row) => selectDate(row)}
            makeModelRowData={async (row, cell, dates, cellindex) => {
              makeModelRowData(row, cell, dates, cellindex);
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default OIWebTableContainer;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/webViewComponents/OIWebTable.jsx